"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, CircleCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CtaGetStarted() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const avatars = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/user_avatar_1.png",
    alt: "Usuario 1"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/user_avatar_2.png",
    alt: "Usuario 2"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/user_avatar_3.png",
    alt: "Usuario 3"
  }];
  return <section data-section-id="259714" id="cta-get-started" className="relative bg-background text-foreground overflow-hidden py-20 lg:py-32">
      {}
      <div className="absolute inset-0 overflow-hidden pointer-events-none -z-10">
        <div className="absolute -top-[10%] -left-[10%] w-[50%] h-[120%] bg-secondary/10 -skew-x-12 transform-gpu" />
        <div className="absolute top-[20%] right-[10%] w-96 h-96 bg-primary/10 rounded-lg blur-3xl" />
      </div>

      <div className="container mx-auto px-4 md:px-6 max-w-[1024px]">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {}
          <div ref={contentRef} className={`flex flex-col justify-center space-y-8 transition-all duration-1000 ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="space-y-6">
              <div className="inline-flex items-center rounded-md border border-border bg-accent px-3 py-1 text-sm font-medium text-primary">
                <span className="flex size-2 rounded-lg bg-primary mr-2 animate-pulse"></span>
                Comienza Ahora
              </div>
              
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default tracking-tight text-primary leading-[1.1]">
                Impulsa tu <span className="text-secondary">Equipo</span>
              </h1>
              
              <p className="text-lg md:text-xl text-muted-foreground max-w-[600px] leading-relaxed font-default">
                Optimiza la comunicación de tu empresa con nuestra plataforma omnicanal. Gestiona clientes, automatiza procesos y escala tu negocio con tecnología de vanguardia diseñada para el éxito.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-2">
              <Button asChild size="lg" className="w-full sm:w-auto h-12 px-8 bg-chart-4 hover:bg-chart-4/90 text-black font-bold rounded-md shadow-md animate-pulse">
                <Link to="/OmnichannelPage">
                  Solicitar Demo
                  <ArrowRight className="ml-2 size-4" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto h-12 px-8 border-primary text-primary hover:bg-primary/5 rounded-md">
                <Link to="/HomePage">
                  Saber Más
                </Link>
              </Button>
            </div>

            {}
            <div className="flex items-center gap-4 pt-6 border-t border-border/60 mt-4">
              <div className="flex -space-x-3">
                {avatars.map((avatar, i) => <div key={i} data-index={i} className="size-10 rounded-md border-2 border-background bg-muted flex items-center justify-center overflow-hidden shadow-sm">
                    <img src={avatar.src} alt={avatar.alt} className="w-full h-full object-cover" data-wvc-srcset={`${avatar.src}-wvc-srcset`} data-wvc-sizes={`${avatar.src}-wvc-sizes`} />
                  </div>)}
              </div>
              <div className="text-sm">
                <p className="font-semibold text-foreground flex items-center gap-1 font-default">
                  Confiado por líderes <CircleCheck className="size-4 text-primary" />
                </p>
                <p className="text-muted-foreground font-default">Únete a las empresas que ya transformaron su presencia digital.</p>
              </div>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`relative mx-auto w-full max-w-[600px] lg:max-w-none transition-all duration-1000 delay-200 ${imageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="relative aspect-square lg:aspect-[4/3] rounded-lg overflow-hidden shadow-2xl border border-border/50 bg-muted">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/teams_cloud_illustration.png" alt="Ilustración 3D de equipos y nube" className="w-full h-full object-cover" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/teams_cloud_illustration.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/teams_cloud_illustration.png-wvc-sizes" />
              {}
              <div className="absolute inset-0 bg-gradient-to-tr from-primary/20 to-transparent mix-blend-overlay pointer-events-none" />
            </div>
            
            {}
            <div className="absolute -bottom-6 -left-6 bg-card p-4 rounded-md shadow-lg border border-border hidden md:block animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-500">
              <div className="flex items-center gap-3">
                <div className="size-10 rounded-md bg-primary/10 flex items-center justify-center">
                  <CircleCheck className="size-5 text-primary" />
                </div>
                <div>
                  <p className="text-sm font-bold text-foreground font-default">Soporte 24/7</p>
                  <p className="text-xs text-muted-foreground font-default">Garantía de Éxito</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}